import { Input as AntdInput } from 'antd';
import { InputProps } from 'antd/lib/input/Input';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../colors-v2';

export interface InputTextMaterialProps extends InputProps {}

const Main = styled(AntdInput)`
  &.dol-input-material {
    &::selection {
      background: ${colorsV2.blue40};
    }
    &.ant-input,
    .ant-input {
      color: ${colorsV2.black100};
      background: transparent;
      box-shadow: none;
      border-radius: 0;
      padding: 0;
      border: none;
      border-bottom: 2px solid ${colorsV2.gray20};

      .ant-form-item-has-error & {
        border-color: ${colorsV2.red100};
      }
      &:hover,
      &:focus {
        color: ${colorsV2.black100};
        background: transparent;
        box-shadow: none;
      }
    }
  }
`;

const InputTextMaterialBase = ({
  className,
  onBlur,
  onFocus,
  value,
  ...rest
}: InputTextMaterialProps) => {
  const inputRef = React.useRef(null);

  return (
    <Main
      bordered={false}
      ref={inputRef}
      value={value}
      className={cl('dol-input-material', value ? 'filled' : '', className)}
      onFocus={(event) => {
        if (value) {
          inputRef?.current?.focus({
            cursor: 'all',
          });
        }
        if (onFocus) {
          onFocus(event);
        }
      }}
      onBlur={(event) => {
        if (onBlur) {
          onBlur(event);
        }
      }}
      {...rest}
    />
  );
};

export const InputTextMaterial = React.memo(InputTextMaterialBase);
